import React from "react";

// Components
import NavDropdown from "react-bootstrap/NavDropdown";
import SiteLink from "./site-link";

export default function SiteNavigation({ navigation }) {
  return (
    <>
      {navigation &&
        navigation.map((link, i) => {
          if (link.navigationDropdownItems) {
            return (
              <NavDropdown
                key={`nav-main-dropdown-${i}`}
                title={link.dropdownText}
                id="main-nav"
              >
                {link.navigationDropdownItems &&
                  link.navigationDropdownItems.map((innerLink, i) => (
                    <SiteLink
                      key={`nav-main-link-${i}`}
                      id="main-nav"
                      link={innerLink}
                      i={i}
                      isDropdown={true}
                    />
                  ))}
              </NavDropdown>
            );
          }

          return (
            <SiteLink
              key={`nav-main-link-${i}`}
              id="main-nav"
              link={link}
              i={i}
            />
          );
        })}
    </>
  );
}
